import styled from 'styled-components';

export const ImageStyled = styled.img`
  display: block;
  background: ${props => props.theme.color.wfGrey200};
  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.color.wfGrey200};
  }
  &::after {
    content: attr(alt);
    font-size: ${props => props.theme.font.size.default};
    color: ${props => props.theme.color.wfGrey900};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 2;
  }
`;
